/* eslint-disable no-invalid-this */
import React from 'react'
import PropTypes from 'prop-types'
import RichTextEditor from 'react-rte'
import { withTranslation } from 'react-i18next'

class MyStatefulEditor extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    content: PropTypes.string,
    onBlur: PropTypes.func,
    limit: PropTypes.bool,
    t: PropTypes.func,
  }
  constructor(props) {
    let value = RichTextEditor.createEmptyValue()
    super(props)
    if (this.props.content) {
      value = RichTextEditor.createValueFromString(this.props.content, 'html')
    }
    this.state = {
      value,
    }
  }
  onChange = (value) => {
    this.setState({ value })
    if (this.props.onChange) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.
      this.props.onChange(value.toString('html'))
    }
  }
  onBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }

  render() {
    const { t } = this.props
    const toolbarConfig = this.props.limit
      ? {
        // Optionally specify the groups to display (displayed in the order listed).
        display: [
          'INLINE_STYLE_BUTTONS',
          'BLOCK_TYPE_BUTTONS',
          'BLOCK_TYPE_DROPDOWN',
        ],
        INLINE_STYLE_BUTTONS: [
          { label: t('common.statefulEditor.bold'), style: 'BOLD', className: 'custom-css-class' },
          { label: t('common.statefulEditor.italic'), style: 'ITALIC' },
          { label: t('common.statefulEditor.underline'), style: 'UNDERLINE' },
        ],
        BLOCK_TYPE_DROPDOWN: [
          { label: t('common.statefulEditor.normal'), style: 'unstyled' },
          { label: t('common.statefulEditor.headingLarge'), style: 'header-one' },
          { label: t('common.statefulEditor.headingMedium'), style: 'header-two' },
          { label: t('common.statefulEditor.headingSmall'), style: 'header-three' },
        ],
        BLOCK_TYPE_BUTTONS: [
          { label: t('common.statefulEditor.unorderedList'), style: 'unordered-list-item' },
          { label: t('common.statefulEditor.orderedList'), style: 'ordered-list-item' },
        ],
      }
      : {
        // Optionally specify the groups to display (displayed in the order listed).
        display: [
          'INLINE_STYLE_BUTTONS',
          'BLOCK_TYPE_BUTTONS',
          'LINK_BUTTONS',
          'BLOCK_TYPE_DROPDOWN',
          'HISTORY_BUTTONS',
        ],
        INLINE_STYLE_BUTTONS: [
          { label: t('common.statefulEditor.bold'), style: 'BOLD', className: 'custom-css-class' },
          { label: t('common.statefulEditor.italic'), style: 'ITALIC' },
          { label: t('common.statefulEditor.underline'), style: 'UNDERLINE' },
        ],
        BLOCK_TYPE_DROPDOWN: [
          { label: t('common.statefulEditor.normal'), style: 'unstyled' },
          { label: t('common.statefulEditor.headingLarge'), style: 'header-one' },
          { label: t('common.statefulEditor.headingMedium'), style: 'header-two' },
          { label: t('common.statefulEditor.headingSmall'), style: 'header-three' },
        ],
        BLOCK_TYPE_BUTTONS: [
          { label: t('common.statefulEditor.unorderedList'), style: 'unordered-list-item' },
          { label: t('common.statefulEditor.orderedList'), style: 'ordered-list-item' },
        ],
      }
    return (
      <RichTextEditor
        toolbarConfig={toolbarConfig}
        value={this.state.value}
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    )
  }
}

MyStatefulEditor.displayName = 'MyStatefulEditor'

export default withTranslation()(MyStatefulEditor)
